<template>
  <div class="wrap-program">
    <div class="box-page">
      <div class="box-title">
        <h1>Creativity Day 2019 Program</h1>
        <a :href="programs.pdfUrl" target="_blank">
          Download Program
        </a>
      </div>
      <div class="box-content">
        <Skeleton
          v-if="isLoading"
          width="100%"
          height="660px"
        />
        <img
          v-if="!isLoading"
          :src="programs.imageUrl"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const Skeleton = () => import('@/components/Loading/Skeleton')

export default {
  components: {
    Skeleton
  },

  data () {
    return {
      programs: {
        pdfUrl: '',
        imageUrl: ''
      }
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.creativity.isLoading,
      programsRaw: state => state.creativity.programs
    })
  },

  methods: {
    matchImgUrl (urls) {
      urls.forEach((data, i) => {
        if (i === 0) {
          this.programs.pdfUrl = `https://admanawards.com/storage/app/pdf/program/${data.pdf}`
          this.programs.imageUrl = `https://admanawards.com/storage/app/img/program/${data.image}`
        }
      })
    }
  },

  created () {
    if (!this.programsRaw) {
      this.$store.dispatch('creativity/getProgram')
    } else {
      this.matchImgUrl(this.programsRaw)
    }
  },

  watch: {
    programsRaw (data) {
      this.matchImgUrl(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-program {
  padding: 22px 0;

  .box-title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {
      font-size: 1.25rem;

      @media only screen and (min-width: $break-m) {
        font-size: 1.75rem;
      }
    }

    a {
      padding: 8px 28px;
      background-color: $active;
      text-align: center;
      font-size: 1.75rem;
      color: white;
    }
  }

  .box-content {
    margin-top: 22px;

    img {
      width: 100%;
    }
  }
}
</style>
